export const ORG_ACCOUNT_TYPE = Object.freeze({
  Internal: "Internal",
  Partner: "Partner",
  Subscription: "Subscription",
  Test: "Test",
  Trial: "Trial"
});
